const MANIFEST = {
  "frame-straightening-carrollton-tx": { w: 680, h: 510, srcset: [480] },
  "collision-repair-carrollton-tx": { w: 1000, h: 667, srcset: [480, 960] },
  "volkswagen-collision-repair-carrollton": { w: 680, h: 510, srcset: [480] },
  "auto-body-paint-carrollton-tx": { w: 382, h: 510, srcset: [] },
  "lamborghini-body-panel-repair-dfw": { w: 680, h: 510, srcset: [480] },
  "westway-collision-shop-interior": { w: 680, h: 510, srcset: [480] },
  "camaro-wheel-alignment-carrollton": { w: 680, h: 510, srcset: [480] },
  "home-hero-blue-lamborghini": { w: 2560, h: 1707, srcset: [768, 1280, 1920] },
  "performance-tuning-carrollton-tx": { w: 1600, h: 640, srcset: [768, 1280] },
  "lamborghini-huracan-performance-tuning": { w: 680, h: 510, srcset: [480] },
  "dodge-ram-performance-upgrade": { w: 680, h: 510, srcset: [480] },
  "mercedes-g-wagon-westway-collision": { w: 680, h: 505, srcset: [480] },
  "rolls-royce-luxury-detailing-carrollton": { w: 680, h: 510, srcset: [480] },
  "rolls-royce-spectre-service-bay": { w: 382, h: 510, srcset: [] },
  "westway-auto-repair-bay": { w: 1066, h: 1600, srcset: [480, 960] },
  "corvette-repair-after-carrollton": { w: 1448, h: 1086, srcset: [480, 960] },
  "happy-customer-westway-collision": { w: 1024, h: 768, srcset: [480, 960] },
  "customer-chevrolet-tahoe-westway": { w: 1024, h: 768, srcset: [480, 960] },
  "westway-collision-shop-carrollton-tx": { w: 1600, h: 900, srcset: [768, 1280] },
  "westway-collision-center-logo": { w: 1200, h: 529, srcset: [480, 960] },
  "westway-collision-center-logo-reversed": { w: 1200, h: 529, srcset: [480, 960] },
  "ford-raptor-diagnostics": { w: 680, h: 510, srcset: [] },
  "frame-chassis-repair": { w: 680, h: 510, srcset: [] },
  "gtr-hunter-alignment": { w: 680, h: 510, srcset: [] },
  "westway-building-dodge-ram": { w: 680, h: 510, srcset: [] },
};

// By default an image is never displayed wider than its natural width
// (prevents blurry upscaling). Pass `bleed` only for full-bleed hero /
// decorative backdrop images that must span the viewport edge to edge.
export const Img = ({ name, alt, className = "", eager = false, sizes = "100vw", bleed = false, ...rest }) => {
  const m = MANIFEST[name] || { w: 1200, h: 800, srcset: [] };
  const base = `/images/${name}`;
  return (
    <img
      src={`${base}.webp`}
      srcSet={[...m.srcset.map((w) => `${base}-${w}.webp ${w}w`), `${base}.webp ${m.w}w`].join(", ")}
      sizes={sizes}
      width={m.w}
      height={m.h}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : undefined}
      decoding="async"
      style={bleed ? undefined : { maxWidth: `${m.w}px` }}
      className={className}
      {...rest}
    />
  );
};
